/**
 * Shared activity dispositions — used by EntityActivityDrawer (Companies/Contacts)
 * and LeadDetailDrawer (Leads/Opportunities).
 */
export const DISPOSITIONS_BY_TYPE = {
  call: [
    'Connected — Positive',
    'Connected — Neutral',
    'Connected — Not Interested',
    'No Answer',
    'Busy / Disconnected',
    'Wrong Number',
    'Left Voicemail',
    'Requested Follow-up',
    'Requested Callback Later',
    'Do Not Contact',
  ],
  meeting: [
    'Held — Positive',
    'Held — Neutral',
    'Held — Not Interested',
    'Rescheduled',
    'Cancelled by Client',
    'Cancelled by Us',
    'No-show',
    'Requested Follow-up',
  ],
  email: [
    'Sent',
    'Replied — Positive',
    'Replied — Neutral',
    'Replied — Not Interested',
    'Bounced',
    'No Response',
    'Requested Follow-up',
  ],
  whatsapp: [
    'Sent',
    'Read',
    'Replied — Positive',
    'Replied — Neutral',
    'No Response',
    'Requested Follow-up',
  ],
  site_visit: [
    'Completed',
    'Rescheduled',
    'Cancelled',
    'No-show',
    'Requested Follow-up',
  ],
  note: [
    'General Note',
    'Requested Follow-up',
  ],
};

// Dispositions that need no Subject/Notes — the outcome speaks for itself
export const NO_DETAIL_DISPOSITIONS = new Set([
  'No Answer',
  'Busy / Disconnected',
  'Wrong Number',
  'Left Voicemail',
  'No-show',
  'Bounced',
  'No Response',
  'Sent',
  'Read',
]);
